import { render, staticRenderFns } from "./ScratchCard.vue?vue&type=template&id=0fdcb4fe&scoped=true&"
import script from "./ScratchCard.vue?vue&type=script&lang=js&"
export * from "./ScratchCard.vue?vue&type=script&lang=js&"
import style0 from "./ScratchCard.vue?vue&type=style&index=0&id=0fdcb4fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdcb4fe",
  null
  
)

export default component.exports